import * as React from "react";
const SvgFiBrandsCss3Alt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 25 24"
    {...props}
  >
    <path
      fill="#151A2D"
      d="m3.644 4.717 1.611 17.356L12.49 24l7.253-1.93 1.613-17.353zM6.94 8.264h5.552v2.129H7.14zM12.5 14.7h2.723l-.257 2.76-2.466.64zm0-2.128v-2.18h3.117l-.202 2.18zm-5.16 0h5.153v2.129H7.539zm11.02 8.392-5.86 1.56v-2.21l-.01.004-4.542-1.211-.31-3.342h2.226l.158 1.698 2.469.64h.002v2.214l.007-.002 4.539-1.208 1.008-10.844H12.5v-2.13h7.24z"
    />
    <path
      fill="#151A2D"
      d="m18.047 8.264-1.009 10.844-4.538 1.207v-2.214l2.466-.639.257-2.76H12.5v-2.129h2.915l.202-2.18H12.5V8.264zM12.5 12.573h-.007v2.13h.007zM12.5 8.264h-.007v2.13h.007zM12.5 18.102h-.008v2.214h.008zM7.813 0h2.685v1.078H8.935v1.078h1.563v1.078H7.813zM11.036 0h2.685v.938h-1.563v.188h1.563v2.156h-2.685v-.985h1.562v-.188h-1.562zM14.257 0h2.686v.938H15.38v.188h1.563v2.156h-2.686v-.985h1.563v-.188h-1.563z"
    />
    <path
      fill="#151A2D"
      d="m18.047 8.264-1.008 10.844-4.539 1.207-.007.002v-2.214l.007-.002 2.466-.639.257-2.76h-2.73v-2.129h2.922l.202-2.18h-3.124V8.264z"
    />
  </svg>
);
export default SvgFiBrandsCss3Alt;
